<template>
  <div>
    <van-popup
      v-model="show"
      class="full-height full-width RegisterVerificate linear-main3"
      :get-container="element || ''"
      :close-on-popstate="true"
      position="right"
    >
      <ld-header
        @click-left="show = false"
        class="font-lg white"
        transparent
        white
      >
        手机双向验证
      </ld-header>

      <div class="white pad8">
        <van-row class="font-lg font20 mt5 padLR8">
          手机双向验证
        </van-row>
      </div>

      <div class="pad8 bg-white round-lg">
        <van-row class="font12 mt5 gray padLR8">
          为了保护您的信息安全，便于今后为您服务，请按以下程序进行手机双向核验。
        </van-row>

        <van-row class="verificate-box mt5 round-md">
          <van-row class="font-bold font20 mt5">
            1. 发送 <span class="main-color">999</span> 至 12306
          </van-row>
          <van-row class="mt5">
            {{ register.message || '请用您手机发送 999 至 12306' }} 每天至多发送3次。
          </van-row>
          <van-row class="font-bold font20 mt5">
            2. 输入短信验证码，完成核验
          </van-row>
          <van-row class="mt5">
            发送短信后，将收到 12306 发送给您的六位数字验证码，请输入验证码
          </van-row>
          

          <van-row
            class="verificate-box__buttons"
            gutter="10"
          >
            <van-field
              v-model="verificateCode"
              class="text-space round-md mt5"
              :placeholder="$t('G235','请输入验证码')"
            />
          
            <ld-button
              class="mt5"
              main2
              size="lg"
              @click="verificate"
            >
              完成注册
            </ld-button>
          </van-row>
        </van-row>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Search, Popup, Cell, CellGroup, Field } from 'vant'
import ldButton from 'Common/ldButton'

export default {
  name: 'RegisterVerificate',
  components: {
    [Popup.name]: Popup,
    [Search.name]: Search,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    ldButton
  },
  props: {
    element:{
      type: String,
      default: ''
    },
    register: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      show: false,
      verificateCode: ''
    }
  },
  methods: {
    async verificate () {
      if (!this.verificateCode) {
        this.$dialog.alert({ message: '验证码不能为空'})
        return
      }
      try {
        await this.$api['trQuery/checkRegisterCode']({
          ...this.register,
          mobileReceiveCode: this.verificateCode
        })
        
        this.$toast.success('账号核验成功')
        this.toggle()
        this.$emit('success')
      } catch (error) {
        this.$toast.fail(error.errMsg)
        throw error
      }
    },
    toggle() {
      this.show = !this.show
    }
  }
}
</script>

<style lang="less">
.RegisterVerificate {
  padding: 0 8px 0;

  .verificate-box {
    padding: 14px;
    background-color: @color-background-gray;

    .verificate-box__buttons {
      margin-top: 14px;
    }
  }

  .verificate-status {
    margin-top: 10px;
    padding: 16px;
  }

  .padLR8 {
    padding: 0 8px;
  }
}
</style>
